
import { catchError, map, mergeMap } from 'rxjs/operators'
import { EpicRefined } from 'interfaces/middleware'
import { SetupDeviceInfoAction, DeviceAction, SetDeviceInfoAction } from 'actions/deviceActions'
import { EMPTY, of } from 'rxjs'
import { DEVICE_ID_KEY } from 'constants/device'
import { generate } from 'randomstring'
import { combineEpics } from 'redux-observable'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { byType } from 'rxOperators/byType'

const getSum = async (deviceId: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(deviceId)
  const digest = await crypto.subtle.digest('SHA-1', data)

  return new Uint32Array(digest)[0]
}

const setDeviceEpic: EpicRefined<DeviceAction> = (action$) => action$.pipe(
  filterRequest(SetDeviceInfoAction.type),
  mergeMap((action) => of(null).pipe(
    mergeMapAsync(async () => {
      const { deviceId, ...restPayload } = action.payload.params

      let deviceIdSum: number | null = null
      if (deviceId) {
        deviceIdSum = await getSum(deviceId)
      }


      return action.success({
        ...restPayload,
        deviceId,
        deviceIdSum,
      })
    }),
    catchError(() => EMPTY),
  ))

)

const setupDeviceEpic: EpicRefined<DeviceAction> = (action$) => action$.pipe(
  byType(SetupDeviceInfoAction.type),
  mergeMap(() => of(null).pipe(
    map(() => {
      let deviceId: string | null = null
      try {
        deviceId = localStorage.getItem(DEVICE_ID_KEY)
      } catch (e) {}

      if (!deviceId) {
        deviceId = generate()
        localStorage.setItem(DEVICE_ID_KEY, deviceId)
      }

      return new SetDeviceInfoAction({
        deviceId,
      })
    }),
    catchError(() => EMPTY),
  ))
)

export const deviceEpic = combineEpics(
  setDeviceEpic,
  setupDeviceEpic,
)
